import { getThemeDefaults } from '@/components/widget/visualizations/RadarChart/stylesTheme';
import { selectionConfig } from '@/components/widget/visualizations/RadarChart/settings';
import LineStyles from '@/components/Editor/Form/fields/LineStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export function generateCollectionSettings(_ref) {
  let {
    theme,
    themeStyles
  } = _ref;
  return {
    title: 'Layer',
    defaultStyles: getThemeDefaults({
      theme,
      styles: themeStyles
    }),
    selectionsLabeled: false,
    selectionConfig: selectionConfig
  };
}

const WidgetEditFormRadarChartCollectionOption = _ref2 => {
  let {
    nameSpace,
    collectionIndex,
    collectionOption,
    colorPallet,
    defaultStyles,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(LineStyles, {
    nameSpace: `${nameSpace}-${collectionIndex}`,
    lineDash: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineDash,
    lineWidth: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineWidth,
    lineColor: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineColor,
    lineBackgroundColor: collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.lineBackgroundColor,
    colorPallet: colorPallet,
    enableGradientPicker: false,
    defaults: {
      lineWidth: defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.lineWidth,
      lineDash: defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.lineDash
    },
    onChange: onChange
  });
};

export default WidgetEditFormRadarChartCollectionOption;